define('modules/editor/views/controls/alignbars',['require','exports','module','base/collection','base/collectionview','./alignbar','ldsh!../../templates/controls/alignbar'],function(require, exports, module){
  "use strict";
  
  var Collection = require("base/collection"),
      CollectionView = require("base/collectionview"),
      AlignmentBarView = require("./alignbar");

  module.exports = CollectionView.extend({
    itemView: AlignmentBarView,
    template: require("ldsh!../../templates/controls/alignbar"),
    initialize: function(options){
      this.collection = new Collection();
    }
  });
});

